import React, { Component } from "react";
import Color from "../Shared/ColorPicker/ColorPalette";
import IconPicker, { icons } from "../Shared/IconPicker/IconPicker";
import { call } from "../Helpers/Nodes";
import InnerLoader from "../Shared/Loader/InnerLoader";
import Loader from "../Shared/Loader/loader";
import { MsalContext } from "@azure/msal-react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import ErrorMessage from "../Shared/Error/ErrorMessage";
import { UpdateRuntimeforLabelandUrlChange } from '../../API/Runtime/RuntimeHelper'
import { getInstances } from "../Helpers/Launch";
import { callApiWithAuthorization } from "../../API/CallApi";
import ServerError from "../Shared/Error/ServerError";
import { OverlayLoader } from "../Shared/Loader/OverlayLoader"
import { removeSpecialCharacters } from "../Entities/utils";
import { withTranslation } from "react-i18next";
import { createPortal, updatePortal } from "../../API/Portal/Portal";
import { getProject } from "../../API/Project/project";

class CreatePortalDialog extends Component {

    static contextType = MsalContext
    defaultData;
    constructor(props) {
        super(props);
        this.state = {
            portalName: "",
            portalDescription: "",
            value: icons[this.props.Portals.length + 1 % 66],
            IconColor: Color(this.props.Portals.length + 1),
            displayColorPicker: false,
            portalError: {
                isValid: true,
                message: ""
            },
            urlError: {
                isValid: true,
                message: ""
            },
            urlName: "",
            urlInitialized: false,
            isActive: true,
            disabled: true,
            isloading: true,
            creatingPortal: false,
        };
    }

    componentDidMount = async () => {
        if (this.props.cloneId !== "") {
            let portal = this.props.Portals.find((portal) => portal._id === this.props.cloneId);
            this.setState({
                portalName: portal.portalName,
                portalDescription: portal.portalDescription,
                value: portal.Icon ? portal.Icon : icons[this.props.Portals.length + 1 % 66],
                IconColor: portal.IconColor ? portal.IconColor : Color(this.props.Portals.length + 1),
                displayColorPicker: false,
                portalError: {
                    isValid: true,
                    message: ""
                },
                isloading: false,
                urlName: portal.urlName,
                urlInitialized: portal.urlName !== "",
                urlError: {
                    isValid: true,
                    message: ""
                }
            });
        }
        if (this.props.viewMode) {
            let { portal } = this.props;
            this.setState({
                portalName: portal.portalName,
                portalDescription: portal.portalDescription,
                value: portal.Icon ? portal.Icon : icons[this.props.Portals.length + 1 % 66],
                IconColor: portal.IconColor ? portal.IconColor : Color(this.props.Portals.length + 1),
                displayColorPicker: false,
                portalError: {
                    isValid: true,
                    message: ""
                },
                isloading: false,
                urlName: portal.urlName,
                urlInitialized: portal.urlName !== "",
                urlError: {
                    isValid: true,
                    message: ""
                }
            });
            this.defaultData = {
                portalName: portal.portalName,
                portalDescription: portal.portalDescription,
                value: portal.Icon ? portal.Icon : icons[this.props.Portals.length + 1 % 66],
                IconColor: portal.IconColor ? portal.IconColor : Color(this.props.Portals.length + 1),
                urlName: portal.urlName,
            }
        } else {
            this.setState({
                isloading: false,
            });
        }
        if (this.props.mutators) {
            this.props.mutators.setFormSaveFunction(() => this.Update);
        }
    };

    InternalPortalForm = () => {
        const { t } = this.props;
        return (
            <>
                <div className="mb-2">
                    <div className="d-flex align-items-center">
                        <div className="form-label" required>
                            {t("name_field_label")}
                        </div>
                        <ErrorMessage
                            valid={this.state.portalError.isValid}
                            error={this.state.portalError.message}
                        />
                    </div>
                    <div className={this.props.viewMode && !this.props.portal.isActive ? "disabled-input-wrapper" : ""}>
                        <input
                            valid={this.state.validName}
                            onChange={this.handlePortalName}
                            className="form-control name-text"
                            autoFocus={true}
                            maxLength={64}
                            type="text"
                            name="Portal"
                            disabled={this.props.viewMode && !this.props.portal.isActive}
                            value={this.state.portalName}
                        />
                    </div>
                </div>
                <div className="mb-2 d-flex align-items-center">
                    <div>
                        <div className="form-label">
                            {t("icon_field_label")}
                        </div>
                        {!this.props.viewMode ? (
                            <IconPicker
                                onChange={this.handleChange}
                                selected={this.state.value}
                            />
                        ) : this.props.viewMode &&
                            this.props.portal.isActive ? (
                            <IconPicker
                                onChange={this.handleChange}
                                selected={this.state.value}
                            />
                        ) : (
                            <div className="p-3 border d-center" style={{ height: 34 }}>
                                <i className={this.state.value}></i>
                            </div>
                        )}
                    </div>
                </div>

                <div className="mb-2">
                    <div className="form-label">
                        {t("description_field_label")}
                    </div>
                    <textarea
                        maxLength="256"
                        disabled={this.props.viewMode && !this.props.portal.isActive}
                        className="form-control"
                        onChange={this.handleDescription}
                        value={this.state.portalDescription}
                        rows="4"
                    ></textarea>
                </div>
                {
                    this.props.project.developerMode &&
                    <div className="mb-3">
                        <div className="d-flex align-items-center">
                            <div className="form-label" required>
                                {t("url_field_label")}
                            </div>
                            <ErrorMessage
                                valid={this.state.urlError.isValid}
                                error={this.state.urlError.message}
                            />
                        </div>
                        <div className="py-1" style={{ wordWrap: "break-word" }}>
                            {process.env.REACT_APP_RUNTIME_URL}/{this.props.organization.url}/{this.props.project.url}/
                            <small className="txt-link">{this.state.urlName}</small>
                        </div>
                        <div className="disabled-input-wrapper">
                            <input
                                onChange={this.handleURL}
                                name="URL"
                                disabled={true}
                                //disabled={this.props.viewMode && this.props.portal.isActive !== "true"}
                                className="form-control"
                                value={this.state.urlName}
                            />
                        </div>
                    </div>
                }
            </>
        )
    }

    InternalPortalButtons = () => {
        const { t } = this.props;
        return (
            <>
                <small className="mt-1">
                    {this.state.creatingPortal && !this.props.viewMode && (
                        <div className="d-inline-block">
                            <InnerLoader borderColor="green" />
                            <span className="me-4 text-success"></span>
                        </div>
                    )}
                </small>
                {!this.props.viewMode && (
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => this.props.onCancel(false)}>
                        {t("buttons.cancel_button_label")}
                    </button>
                )}
                <button
                    type={this.props.viewMode ? 'button' : 'submit'}
                    className="btn btn-primary"
                    ref={(Save) => (this.saveRef = Save)}
                    onClick={this.props.viewMode ? this.Update : this.Create}
                    disabled={this.state.disabled}
                >
                    {this.props.viewMode ?
                        t("buttons.save_button_label")
                        :
                        t("buttons.create_button_label")
                    }
                </button>
                {this.state.creatingPortal && this.props.viewMode && (
                    <small className="mt-1 ms-2">
                        <div className="d-inline-block">
                            <InnerLoader borderColor="green" />
                            <span className="me-4 text-success"></span>
                        </div>
                    </small>
                )}
            </>
        );
    }


    render() {
        if (this.state.isloading) {
            return (
                <Loader />
            )
        }
        if (this.state.showServerError) {
            return (
                <ServerError
                    error={this.state.errorMessage} />
            )
        }
        const { t } = this.props;
        return (
            !this.props.viewMode ?
                (
                    <Dialog
                        width={"40%"}
                        title={t("title")}
                        onClose={() => this.props.onCancel(false)}>
                        <form onSubmit={this.Create}>
                            <this.InternalPortalForm></this.InternalPortalForm>
                            <DialogActionsBar layout="end">
                                <this.InternalPortalButtons></this.InternalPortalButtons>
                            </DialogActionsBar>
                        </form>
                        {this.state.creatingPortal && <OverlayLoader />}
                    </Dialog>
                )
                :
                (
                    <>
                        {this.state.creatingPortal && <OverlayLoader />}
                        <this.InternalPortalForm></this.InternalPortalForm>
                        <this.InternalPortalButtons></this.InternalPortalButtons>
                    </  >
                )
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.disabled !== this.state.disabled && this.props.mutators) {
            this.props.mutators.setFormsWithChanges(prevValue => ({
                ...prevValue,
                portalForm: !this.state.disabled
            }))
        }
    }

    handlePortalName = (e) => {
        let { portalError } = this.state;
        const { t } = this.props;
        let portalName = e.target.value.trim()
        let specialCharactersEntered = /[`!@#$%^&*()+={}|\[\]:;<>?,]/g.test(portalName);
        if (portalName === "") {
            portalError.isValid = false
            portalError.message = t("errors.name_required")
        } else if (portalName.match(/^\d/)) {
            portalError.isValid = false
            portalError.message = t("errors.name_starts_with_number")
        } else if (specialCharactersEntered) {
            portalError.isValid = false
            portalError.message = t("errors.name_contain_specical_character")
        } else {
            let exist = this.props.Portals.find((x) =>
                removeSpecialCharacters(x.portalName.trim().toLowerCase()) ===
                removeSpecialCharacters(portalName.trim().toLowerCase())
            );
            if (exist) {
                portalError.isValid = false
                portalError.message = t("errors.name_in_use")
                if (
                    this.props.viewMode &&
                    this.props.portal.portalName === exist.portalName
                ) {
                    portalError.isValid = true
                    portalError.message = ""
                }
            } else {
                portalError.isValid = true
                portalError.message = ""
            }
        }
        const portalUrl = this.getUrlForName(portalName);
        this.setState(
            {
                portalName: e.target.value,
                portalError: portalError,
                urlName: portalUrl,
            },
            this.CheckURl
        );
    };

    getUrlForName = (name) => {
        let portalUrl = name.replace(/[^a-zA-Z0-9-._~]/g, "");
        if (portalUrl === "") {
            portalUrl = "portal";
        }
        // }
        // let counter = 0;
        // for (let index = 0; index < this.props.Portals.length; index++) {
        //     if (this.props.Portals[index].urlName === portalUrl) {
        //         counter++;
        //     }
        // }
        // if (counter > 0) {
        //     portalUrl = portalUrl + counter;
        // }
        return portalUrl;
    };

    setURL = (e) => {
        this.setState(
            {
                urlName: this.state.portalName.replace(
                    /[^a-zA-Z0-9-._~]/g,
                    ""
                ),
            },
            () => {
                this.CheckURl();
            }
        );
    };

    handleDescription = (e) => {
        this.setState(
            {
                portalDescription: e.target.value,
            },
            () => {
                this.setDisabled();
            }
        );
    };

    handleChange = (props, value) => {
        this.setState(
            {
                value: props,
            },
            () => {
                this.setDisabled();
            }
        );
    };

    handleColorChange = (e) => {
        this.setState(
            {
                IconColor: e.value,
            },
            () => {
                this.setDisabled();
            }
        );
    };

    handleOpen = () => {
        this.setState({
            displayColorPicker: !this.state.displayColorPicker,
        });
    };

    handleClose = () => {
        this.setState({
            displayColorPicker: false,
        });
    };

    handleURL = (e) => {
        this.setState(
            {
                urlName: e.target.value
            },
            () => {
                this.CheckURl();
                this.setDisabled();
            }
        );
    };

    CheckURl = (e) => {
        let { urlError, urlName } = this.state;
        const { t } = this.props;
        let specialCharactersEntered = !/[^a-zA-Z0-9-._~]/g.test(urlName);
        if (urlName === "") {
            urlError.isValid = false
            urlError.message = t("errors.url_required")
        } else if (!specialCharactersEntered) {
            urlError.isValid = false
            urlError.message = t("errors.url_contain_specical_character")
        } else {
            let exist = this.props.Portals.find((portal) => portal.urlName === urlName);
            if (exist) {
                if (this.props.viewMode && this.props.portal.portalName === exist.portalName) {
                    urlError.isValid = true
                    urlError.message = ""
                } else {
                    urlError.isValid = false
                    urlError.message = t("errors.url_in_use")
                }
            } else {
                urlError.isValid = true
                urlError.message = ""
            }
        }
        this.setState({
            urlError: urlError,
        }, () => {
            this.setDisabled()
        });
    };

    setDisabled = () => {
        let condition = true;

        if (this.props.portal) {
            condition =
                this.defaultData.portalName.trim() !== this.state.portalName.trim() ||
                this.defaultData.urlName.trim() !== this.state.urlName.trim() ||
                this.defaultData.portalDescription.trim() !== this.state.portalDescription.trim() ||
                this.defaultData.IconColor !== this.state.IconColor ||
                this.defaultData.value !== this.state.value;
        }

        if (
            !this.state.urlError.isValid ||
            this.state.portalName.trim() === "" ||
            !this.state.portalError.isValid
        ) {
            condition = false;
        }

        if (condition) {
            this.setState({
                disabled: false,
            });
        } else {
            this.setState({
                disabled: true,
            });
        }

        if (this.props.mutators) {
            this.props.mutators.setFormsWithChanges(prevValue => ({
                ...prevValue, portalForm: true
            }))
        }
    };

    getOrder = () => {
        if (this.props.Portals.length === 0) {
            return "10000000000";
        }
        const order = parseInt(this.props.Portals[this.props.Portals.length - 1].order) + 10000000000;
        return String(order);
    };

    Create = async (e) => {
        try {
            e.preventDefault();

            this.saveRef.disabled = true;

            this.setState({
                creatingPortal: true,
            });

            console.time("Create portal");

            const portal = await createPortal({
                projectId: this.props.project._id,
                subscriptionId: this.props.organization.subscriptionId,
                properties: {
                    portalName: this.state.portalName.trim().replace(/\s\s+/g, " "),
                    portalDescription: this.state.portalDescription,
                    Icon: this.state.value,
                    IconColor: this.state.IconColor ? this.state.IconColor : Color(this.props.Portals.length + 1),
                    urlName: this.state.urlName,
                    isActive: true,
                    logoUrl: "",
                    faviconUrl: "",
                    enableDashboard: true,
                    enableReporting: true,
                    isWorkflowEnabled: true,
                    order: this.getOrder(),
                    navigationBarOrientation: "Top",
                    navigateToDefaultPage: false,
                    targetPageId: "",
                },
            });
            console.timeEnd("Create portal");
            if (portal.status && portal.status === "Failure") {
                this.props.onCancel(true)
            } else {
                if (this.props.cloneId !== "") {
                    await call("clonePortal", "POST").with({
                        oldId: this.props.cloneId,
                        newId: portal._id,
                    });
                }
                this.props.onClose(portal);
            }
        } catch (e) {
            this.setState({ showServerError: true, errorMessage: "Something went wrong while creating portal." })
        }
    };

    Update = async (e) => {

        try {
            e.preventDefault();
            this.saveRef.disabled = true;
            this.setState({
                creatingPortal: true,
            });
            const properties = {
                portalName: this.state.portalName.trim().replace(/\s\s+/g, " "),
                portalDescription: this.state.portalDescription,
                Icon: this.state.value,
                IconColor: this.state.IconColor ? this.state.IconColor : Color(this.props.Portals.length + 1),
                urlName: this.state.urlName,
            };
            await updatePortal(this.props.portal._id, properties);
            const portal = { ...this.props.portal, ...properties };
            if (this.props.portal.portalName !== this.state.portalName) {
                let type = "Portal";
                let { context } = this;
                let orgId = this.props.organization._id;
                let portalId = this.props.portal._id
                let project = await getProject(this.props.project._id);
                let Instances = project.instances;
                for (let instance of Instances) {
                    if (instance.Published) {
                        let data = {
                            updatedUrl: this.state.urlName,
                            updatedLabel: this.state.portalName
                        }
                        await UpdateRuntimeforLabelandUrlChange(
                            type,
                            context,
                            orgId,
                            instance._id,
                            portalId,
                            data
                        );
                    }
                }
            }

            if (this.props.portal.portalName.trim() !== this.state.portalName.trim()) {
                // await callApiWithAuthorization(
                //     "/api/v0/nodes/updatePortalFolderName",
                //     {
                //         method: "POST",
                //         headers: {
                //             "Content-Type": "application/json",
                //         },
                //         body: JSON.stringify({
                //             portalId: this.props.portal._id,
                //             projectId: this.props.project._id,
                //             oldPortalName: this.props.portal.portalName,
                //             portalName: properties.portalName,
                //         }),
                //     }
                // );
                if (!this.props.mutators) {
                    window.location.href = `/${this.props.organization.orgName}/${this.props.project.name}/Portals/${properties.portalName}/General`;
                }
            }
            this.defaultData = { ...properties }
            this.setState({
                disabled: true,
                creatingPortal: false,
                portalName: properties.portalName,
            });
            if (this.props.onSubmit) {
                this.props.onSubmit(portal);
            }
        } catch (e) {
            this.setState({ showServerError: true, creatingPortal: false, errorMessage: "Something went wrong while updating portal." })
        } finally {
            if (this.props.mutators && this.props.mutators.setFormsWithChanges) {
                this.props.mutators.setFormsWithChanges(prevValue => ({
                    ...prevValue, portalForm: false
                }))
            }
        }
    };
}

export default withTranslation([
    "portal/create_dialog",
])(CreatePortalDialog);
